import { withStyles } from '@material-ui/styles';
import { withDefaults } from './withDefaults';
/**
 * Set the display name of a component so it propertly shows in the React Dev Tools and Storybook
 * @param Component The component to set the display name for
 * @param name The name to set
 */
export function setDisplayName(Component, name) {
    Object.defineProperty(Component, 'displayName', { value: name });
}
/**
 * A higher order component that applies default props and styles to a component.
 * This mostly serves as a better interface than the withDefaults HOC plus the withStyles HOC.
 * By using this instead, you are ensuring that the `displayName` and class prefix is properly set (since it uses
 * withStyles each time), ensuring that the dreaded `<[Object object] />` component name is avoided.
 * @param name The name of the component. This is used to create both the displayName and the class prefix.
 * @param Component The component to wrap.
 * @param options The options to apply to the component.
 * @param options.defaultProps The default props to apply to the component.
 * @param options.styles The styles to apply to the component.
 * @param options.stylesOptions The options to apply to the styles.
 */
export function withDefaultPropsAndStyles(name, Component, { defaultProps = {}, styles = {}, stylesOptions = {}, } = {}) {
    const WrappedComponent = withDefaults(withStyles(styles, Object.assign({ name }, stylesOptions))(
    // Casting to any here is required to pass what we need to the withStyles HOC.
    // We're casting back to T in the return statement.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Component), defaultProps);
    setDisplayName(WrappedComponent, name);
    return WrappedComponent;
}
//# sourceMappingURL=withDefaultPropsAndStyles.js.map